"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = __importDefault(require("./styles"));
var types_1 = require("./types");
var CollapsibleMessage = function (_a) {
    var type = _a.type, visible = _a.visible, children = _a.children, timeout = _a.timeout, _b = _a.position, position = _b === void 0 ? types_1.CollapsibleMessagePosition.Static : _b;
    var classes = styles_1.default({ type: type, position: position });
    return (react_1.default.createElement(core_1.Collapse, { className: classes.root, in: visible, timeout: timeout },
        react_1.default.createElement("div", { className: classes.message }, children)));
};
exports.default = CollapsibleMessage;
